import React from 'react';
import { Link } from 'react-router-dom';
import './Blogging.css'; // Importing SCSS file for styling

// Sample data for Quranic verses
const verses = [
    {
        surah: "سورة الفاتحة",
        translation: "In the name of Allah, the Most Gracious, the Most Merciful. Praise be to Allah, the Lord of all the worlds. The Most Gracious, the Most Merciful. Master of the Day of Judgment. You alone we worship, and You alone we ask for help. Guide us on the Straight Path. The path of those who have received Your grace; not the path of those who have brought down wrath upon themselves, nor of those who have gone astray.",
        link: "/surah-al-fatiha"
    },
    {
        surah: "سورة البقرة",
        translation: "This is the Book about which there is no doubt, a guidance for those conscious of Allah. Who believe in the unseen, establish prayer, and spend out of what We have provided for them. And who believe in what has been revealed to you, [O Muhammad], and what was revealed before you, and of the Hereafter they are certain.",
        link: "/surah-al-baqarah"
    },
    {
        surah: "سورة الإخلاص",
        translation: "Say, 'He is Allah, [who is] One, Allah, the Eternal Refuge. He neither begets nor is born, Nor is there to Him any equivalent.'",
        link: "/surah-al-ikhlas"
    },
    {
        surah: "سورة الكافرون",
        translation: "Say, 'O disbelievers, I do not worship what you worship. Nor are you worshippers of what I worship. Nor will I be a worshipper of what you worship. Nor will you be worshippers of what I worship. For you is your religion, and for me is my religion.'",
        link: "/surah-al-kafirun"
    },
    {
        surah: "سورة العنكبوت",
        translation: "And [He] who created the heavens and the earth in truth. And the Day the Hour appears, the wrongdoers will lose.",
        link: "/surah-al-ankabut"
    }
];
const courses = [
    {
        title: "Tajweed Course",
        icon: "fas fa-book", // Using Font Awesome book icon for Tajweed
        link: "/tajweed-course"
    },
    {
        title: "Hifz Course",
        icon: "fas fa-graduation-cap", // Using Font Awesome graduation cap icon for Hifz
        link: "/hifz-course"
    },
    {
        title: "Quran Reading Course",
        icon: "fas fa-quran", // Using Font Awesome Quran icon for Reading Quran
        link: "/quran-reading-course"
    }
];

const Blogging = () => {
    return (
        <div className="blogging-container">
            <div className="content-wrapper">
                <div className="left-section">
                <div className="image-container">
                        <img src="./images/g1.jpeg" alt="Descriptive Alt Text" />
                    </div>
                    <main className="main-content">
                        <section className="blog-content">
                            <article>
                                <h2>The Vital Role of Acquiring Knowledge Through the Quran</h2>
                                <p>In the journey of life, knowledge serves as a beacon guiding us through the complexities of existence. Among the myriad sources of knowledge, the Quran stands out as a divine guide that not only enriches our understanding but also shapes our moral and spiritual outlook. Seeking knowledge through the Quran is not merely a religious obligation but a transformative process that brings profound benefits in this life and the Hereafter.</p>

                                <h3>The Quran: A Source of Unparalleled Wisdom</h3>
                                <p>The Quran is a treasure trove of wisdom and guidance, offering insights into the nature of existence, morality, and our relationship with Allah. As Allah says in the Quran:</p>
                                <blockquote>
                                    <p>"Say, 'Are those who know equal to those who do not know?' Only they will remember [who are] people of understanding." (Quran 39:9)</p>
                                </blockquote>
                                <p>This verse highlights the immense value of knowledge and its distinction from ignorance. It underscores that those who seek knowledge are elevated in their understanding and awareness, thus distinguishing themselves in the eyes of Allah.</p>

                                <h3>The Importance of Knowledge in Islam</h3>
                                <p>The pursuit of knowledge is highly emphasized in Islam. The Prophet Muhammad (peace be upon him) said:</p>
                                <blockquote>
                                    <p>"Seeking knowledge is an obligation upon every Muslim." (Sunan Ibn Majah)</p>
                                </blockquote>
                                <p>This Hadith reinforces the notion that acquiring knowledge is not optional but a fundamental duty for every Muslim. Knowledge equips individuals with the ability to make informed decisions, act justly, and lead a life that aligns with divine principles.</p>

                                <h3>Knowledge as a Means to Success</h3>
                                <p>The Quran explicitly connects knowledge with success. Allah says:</p>
                                <blockquote>
                                    <p>"And He will teach him writing and wisdom and the Torah and the Gospel." (Quran 3:48)</p>
                                </blockquote>
                                <p>This verse reflects the comprehensive nature of knowledge, which includes spiritual, intellectual, and moral dimensions. Knowledge through the Quran helps us navigate life's challenges with divine wisdom, leading to success in both worldly affairs and the Hereafter.</p>

                                <h3>Spiritual Enlightenment Through the Quran</h3>
                                <p>Engaging with the Quran fosters a deep spiritual connection with Allah. As we recite and reflect on its verses, we gain insight into divine guidance that brings inner peace and alignment with Allah's will. This spiritual enrichment helps us cultivate a life of purpose and fulfillment.</p>

                                <h3>Moral and Ethical Guidance</h3>
                                <p>The Quran provides a framework for moral and ethical behavior. Allah commands:</p>
                                <blockquote>
                                    <p>"O you who have believed, be persistently standing firm in justice, witnesses for Allah, even if it be against yourselves or parents and relatives." (Quran 4:135)</p>
                                </blockquote>
                                <p>This guidance emphasizes the importance of justice, honesty, and integrity in our actions, shaping our interactions with others and contributing to a just society.</p>

                                <h3>The Transformative Journey of Learning</h3>
                                <p>Learning the Quran is a transformative journey that requires dedication and sincerity. As stated in the Quran:</p>
                                <blockquote>
                                    <p>"And this Quran has been revealed to me that I may warn you thereby and whomever it reaches." (Quran 6:19)</p>
                                </blockquote>
                                <p>This verse underscores the Quran’s role as a guide for those who seek to enhance their understanding and align their lives with divine teachings. The knowledge gained from the Quran enriches one's life, leading to both spiritual and intellectual growth.</p>

                                <h2>Featured Surahs</h2>
                                {verses.map((verse, index) => (
                                    <div key={index} className="surah-card">
                                        <h3>{verse.surah}</h3>
                                        <p><strong>Translation:</strong> {verse.translation}</p>
                                    </div>
                                ))}
                            </article>
                        </section>
                    </main>
                </div>
                <div className="right-section">
                    <h2>Recently Updated</h2>
                    <ul className="updated-list">
                        {courses.map((course, index) => (
                            <li key={index} className="updated-item">
                                <Link to={course.link}>
                                    <i className={course.icon}></i> {/* Font Awesome Icon */}
                                    {course.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Blogging;
